<template>
  <div class="take-detail-list">
    <div class="deatil-title">
      <!-- <span> 提现记录 </span> -->
      <!-- <span class="btn-more btn" @click="moreSettleDetail"> 查看更多 </span> -->
    </div>
    <settlementDetail> </settlementDetail>
    <!-- <Table
      v-loading="loading"
      :tableData="tableData"
      :tableField="tableField"
      key="incomeHomeTable"
      :tableInfo="tableInfo"
      :isShowPagination="false"
      :tabletype="true"
    ></Table> -->
  </div>
</template>

<script>
// import Table from '../table';
import settlementDetail from '../../settlementDetail.vue';
import { getRecordList } from '@/api/income';

export default {
  name: 'indexPageTable',
  components: {
    // Table
    settlementDetail,
  },
  props: {
    isRefreshTable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isRefreshTable(val) {
      if (val) {
        this.fetchRecordList();
      }
    },
  },
  data() {
    return {
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      defaultStart:
        new Date(
          new Date(new Date() - 3600 * 1000 * 24 * 30 * 3).toString(),
        ).getTime() / 1000, // 0点时间戳
      defaultEnd:
        new Date(new Date(new Date()).toString()).getTime() / 1000 +
        (24 * 60 * 60 - 1), // 当天23:59:59点时间戳
      tableData: [],
      //noData:'three',
      tableField: [
        { label: '日期', prop: 'time' },
        {
          label: '订单号',
          prop: 'id',
        },
        {
          label: '类型',
          prop: 'money_type',
        },
        {
          label: '提现数额',
          prop: 'money',
        },
        {
          label: '税费',
          prop: 'taxe',
        },
        {
          label: '手续费',
          prop: 'service_charge',
        },
        {
          label: '到账金额',
          prop: 'real_money',
        },
        {
          label: '状态',
          prop: 'state',
        },
        {
          label: '操作',
          prop: 'operation',
        },
      ],
      loading: false,
    };
  },
  mounted() {
    this.fetchRecordList();
  },
  methods: {
    moreSettleDetail() {
      //结算中心-查看更多点击埋点
      this.$log('check_more_click', 85433, { v7: 1 });
      this.$router.push({ name: 'settlementDetail' });
    },
    async fetchRecordList() {
      try {
        this.loading = true;
        let data = {
          // 默认请求最近一月
          money_type: 999,
          start_time: this.defaultStart,
          end_time: this.defaultEnd,
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          dtype: 1,
        };
        const res = await getRecordList(data);

        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.take-detail-list {
  //margin-top: 30px;
  margin-bottom: 500px;
  .deatil-title {
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    .btn-more {
      width: 130px;
      height: 36px;
      background: #fffaed;
      border: 1px solid #ffc973;
      border-radius: 18px;
      font-size: 16px;
      color: $--color-primary;
      line-height: 36px;
      text-align: center;
    }
  }
  .btn {
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
  .btn-forbid {
    background: #d9d9d9 !important;
    &:hover {
      filter: brightness(100%);
    }
  }
}
</style>
